import type { ReactNode } from "react";
import {
  AnimatedTabs,
  AnimatedTabsContent,
  AnimatedTabsList,
  AnimatedTabsTrigger,
} from "../ui/animated-tabs";

export type RegimeDetailTab = "controls" | "publications";

/** TanStack Router supplies hashes without the leading #. */
export function regimeDetailTab(hash: string): RegimeDetailTab {
  return hash === "publications" ? "publications" : "controls";
}

export function RegimeDetailTabs({
  hash,
  onTabChange,
  controlCount,
  controls,
  sources,
}: {
  hash: string;
  onTabChange: (tab: RegimeDetailTab) => void;
  controlCount: number | null;
  controls: ReactNode;
  sources: ReactNode;
}) {
  return (
    <AnimatedTabs
      id="publications"
      value={regimeDetailTab(hash)}
      onValueChange={(value) => {
        if (value === "controls" || value === "publications")
          onTabChange(value);
      }}
      className="mt-4 gap-4 pb-10 sm:mt-6"
    >
      <AnimatedTabsList aria-label="Regime details">
        <AnimatedTabsTrigger value="controls">
          Controls
          {controlCount !== null ? (
            <span className="text-xs font-normal tabular-nums text-muted-foreground">
              {controlCount}
            </span>
          ) : null}
        </AnimatedTabsTrigger>
        <AnimatedTabsTrigger value="publications">
          Sources & scraping
        </AnimatedTabsTrigger>
      </AnimatedTabsList>
      <AnimatedTabsContent value="controls">{controls}</AnimatedTabsContent>
      <AnimatedTabsContent value="publications">{sources}</AnimatedTabsContent>
    </AnimatedTabs>
  );
}
